import { FormControl, Validators } from '@angular/forms';
import {
  EoCustomControlConfig,
  EoFormPanelConfig,
  EoTextAreaConfig,
} from 'ngx-eo-web-components';

export const surgeryUnableToContactFormPanel = new EoFormPanelConfig({
  name: 'surgeryUnableToContactForm',
  panelContentStyleClass: 'grid',
  config: [
    new EoTextAreaConfig({
      name: 'unableToContactComments',
      styleClass: 'col-12',
      type: 'textarea',
      label: 'Σχόλια Αδυναμίας Επικοινωνίας',
      placeholder: 'Συμπληρώστε σχόλια',
      rows: 3,
      cols: 30,
      control: new FormControl('', []),
    }),
  ],
});

export const surgeryUnableToContactFormConfig: EoFormPanelConfig[] = [
  surgeryUnableToContactFormPanel,
];
